<template>
    <div class="content" v-loading="hasLoading" v-if="hasLoading"></div>
    <div class="content" v-else>
        <router-view v-if="hasPermission"></router-view>
        <div v-else class="limit-container">
            <div class="limit-container-inner">
                <img src="../static/img/noAauthority.png" class="limit-img" alt="">
                <span class="limit-text">当前角色无权访问该服务，请联系管理员为您添加权限。</span>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
const jdrRouteMap = {
    '/instance/retail/list': {
        defaultRoute: '/instance/retail/list',
    },
    '/instance/retail/create': {
        defaultRoute: '/instance/retail/list',
    },
    '/instance/retail/detail': {
        defaultRoute: '/instance/retail/list',
    },
    '/instance/retail/detail/performance': {
        defaultRoute: '/instance/retail/detail/performance',
    },
};

const basicRouteMap = {
    '/instance/basic/list': {
        defaultRoute: '/instance/basic/list',
    },
    '/instance/basic/create': {
        defaultRoute: '/instance/basic/create',
    },
    '/instance/basic/detail': {
        defaultRoute: '/instance/basic/detail',
    },
    '/instance/basic/detail/performance': {
        defaultRoute: '/instance/basic/detail/performance',
    },
};
const SSHRouteMap = {
    '/ssh/list': {
        defaultRoute: '/ssh/list',
    },
    '/ssh/detail': {
        defaultRoute: '/ssh/detail',
    },
};
const gameInstanceRouteMap = {
    '/instance/game/list': {
        defaultRoute: '/instance/game/list',
    },
    '/instance/game/create': {
        defaultRoute: '/instance/game/create',
    },
};
export default {
    name: 'App',
    components: {},
    data() {
        return {
            path: '',
            hasLoading: true,
        };
    },
    computed: {
        hasPermission() {
            let userInfo = this.$store.state.userInfo.data || {};
            if (!userInfo.meta) {
                return false;
            }
            let meta = JSON.parse(userInfo.meta);
            let isJdr, isJdd;
            let path = this.path || location.pathname;
            if (meta.jdbu === 'jdr' && meta.vipInfo === 'jd') {
                isJdr = true
            } else {
                isJdr = false
            }
            if (meta.jdbu === 'jdd' && meta.vipInfo === 'jd') {
                isJdd = true
            } else {
                isJdd = false
            }
            if (isJdr) {
                if (jdrRouteMap[path] || SSHRouteMap[path]) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (isJdd) {
                    if (!basicRouteMap[path] && !jdrRouteMap[path] && !gameInstanceRouteMap[path]) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    if (!jdrRouteMap[path]) {
                        return true;
                    } else {
                        return false;
                    }
                }

            }
        },
    },
    created() {
        Vue.prototype.Config = Config.init(this);
        this.path = location.pathname;
        //this.getUserInfo();
    },
    mounted() {
        document.title = this.$t('text.title');
        // 全局设置a标签不可以拖动
        document.addEventListener('dragstart', e => {
            if (e.target.tagName === 'A') {
                e.preventDefault()
            }
        })
    },
    methods: {
    },
    watch: {
        $route: {
            handler(newRoute) {
                this.path = newRoute.path;
                if (window.toRoutePath) {
                    const { path } = newRoute;
                    setTimeout(() => window.toRoutePath(path, true), 500);
                }
            },
            // 深度观察监听
            deep: true
        },

        '$store.state.userInfo': {
            handler(newVal, oldVal) {
                this.hasLoading = false;
            },
            deep: true
        }
    },
    destroyed() { }
};
</script>

<style lang="scss">
@import "../src/assets/scss/global";
</style>

<style lang="scss">
.limit-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    // align-items: center;
    padding-top: 80px;

    .limit-container-inner {
        display: inline-flex;
        align-items: center;
        flex-direction: column;
    }

    img {
        width: 224px;
    }

    .limit-text {
        margin: 40px 0 10px;
        text-align: center;
        font-size: 24px;
        font-family: 500;
        padding: 0 0 0 8px;
    }

    .limit-dis {
        font-size: 14px;
        color: #999;
    }
}
// 分页组件内的前往第几页的数字在框内居中
.el-pagination__editor.el-input .el-input__inner {
  text-align: center!important;
}
// 复制成功的 提示 修改
.customToastWidth {
    top: 60px !important;
    min-width: 116px;
    display: flex;
    padding: 16px;
    align-items: center;
    border-radius: 8px;
    border: 1px solid #FFF;
    background: #FFF;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.02), 0 2px 6px 2px rgba(0, 0, 0, 0.02), 0 3px 8px 4px rgba(0, 0, 0, 0.02);
}
// 解决表格表头无数据时 提示的文字宽度撑满整个表格
.el-table__empty-block {
    width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue